// #ux-redesign-start: <Tooltip> primitiva DS (Paso 4 - Floating UI/Radix)
// Reemplaza react-tooltip@4 (legacy con bugs de portales que disparaban
// `NotFoundError: removeChild` en React 16 al hacer unmount masivo).
//
// Implementacion: wrapper headless de @radix-ui/react-tooltip (que usa
// Floating UI internamente para posicionamiento). Trae a11y "for free"
// (role=tooltip, aria-describedby, escape, foco gestionado, side/align/
// avoidCollisions).
//
// Uso minimo:
//   <Tooltip content="Anna Keipert">
//     <button>Hover me</button>
//   </Tooltip>
//
// API avanzada:
//   <Tooltip content={<UserCard />} side="bottom" align="start" delayDuration={150}>
//     <span data-id="x">...</span>
//   </Tooltip>
//
// PORTABILIDAD: idéntico para Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import * as RT from '@radix-ui/react-tooltip';

const Tooltip = ({
  children,
  content,
  side = 'bottom',
  align = 'center',
  sideOffset = 6,
  alignOffset = 0,
  delayDuration = 200,
  open,
  defaultOpen,
  onOpenChange,
  asChild = true,
  className = '',
  arrow = true,
  variant = 'dark', // 'dark' | 'light'
}) => {
  if (!content) {
    // Sin contenido → no envolvemos, devolvemos children tal cual (evita
    // wrappers innecesarios en el arbol).
    return <>{children}</>;
  }
  return (
    <RT.Provider delayDuration={delayDuration} skipDelayDuration={0}>
      <RT.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
        <RT.Trigger asChild={asChild}>{children}</RT.Trigger>
        <RT.Portal>
          <RT.Content
            side={side}
            align={align}
            sideOffset={sideOffset}
            alignOffset={alignOffset}
            avoidCollisions
            collisionPadding={8}
            className={`ds-tooltip ds-tooltip--${variant} ${className}`}
          >
            {content}
            {arrow && (
              <RT.Arrow className="ds-tooltip__arrow" width={10} height={5} />
            )}
          </RT.Content>
        </RT.Portal>
      </RT.Root>
    </RT.Provider>
  );
};

export default Tooltip;
// #ux-redesign-end
